import React from "react";
import Skeleton from "../shared/skeleton-component";

const DropOffModalSkeleton = () => {
  return (
    <div style={{ display: "grid", gap: "30px", marginTop: "30px" }}>
      <div>
        <Skeleton width="100%" height="40px" />
      </div>
      <div style={{ display: "grid", gap: "30px" }}>
        <div>
          <Skeleton width="100%" height="40px" />
        </div>
        <div>
          <Skeleton width="360px" height="78px" mobWidth="80vw" />
        </div>
        <div>
          <Skeleton width="100%" height="121px" />
        </div>
        <div style={{ display: "grid", gap: "30px" }}>
          <Skeleton width="100%" height="56px" />
          <Skeleton width="100%" height="56px" />
        </div>
      </div>
    </div>
  );
};

export default DropOffModalSkeleton;
